import React from 'react'
import 'regenerator-runtime/runtime'
import MyEvents from '../routes/MyEvents'

const Routes = () => {
  return <MyEvents />
}

export default Routes
